import { render, staticRenderFns } from "./phase.vue?vue&type=template&id=d0398bfa&scoped=true"
import script from "./phase.vue?vue&type=script&lang=js"
export * from "./phase.vue?vue&type=script&lang=js"
import style0 from "./phase.vue?vue&type=style&index=0&id=d0398bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0398bfa",
  null
  
)

export default component.exports